"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationItem = function PaginationItem(_ref) {
  var number = _ref.number,
      onClick = _ref.onClick,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "p-pagination__item"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)("p-pagination__link", {
      "is-active": isActive
    }),
    onClick: onClick,
    "aria-current": isActive ? "page" : undefined,
    type: "button"
  }, number));
};

var _default = PaginationItem;
exports.default = _default;